/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Achievementsblade_Gameswithachievements3Inputs */

const id_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game dengan Pencapaian Epic`)
};

const ms_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan dengan Pencapaian Epic`)
};

const da_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil med Epic Achievements`)
};

const de_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiele mit Epic-Errungenschaften`)
};

const en_us2_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games with Epic Achievements`)
};

const es_es2_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos con logros de Epic`)
};

const es_mx2_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos con logros de Epic`)
};

const fil_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Larong May Epic Achievements`)
};

const fr_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux avec succès Epic`)
};

const it_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi con risultati Epic`)
};

const hu_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékok Epic teljesítményekkel`)
};

const nl_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games met Epic-prestaties`)
};

const no_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill med Epic-prestasjoner`)
};

const pl_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gry z osiągnięciami Epic`)
};

const pt_br2_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games with Epic Achievements`)
};

const pt_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos com conquistas Epic`)
};

const ro_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri cu realizări Epic`)
};

const fi_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelit, joissa on Epic-saavutuksia`)
};

const sv_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spel med Epic-prestationer`)
};

const vi_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game có thành tích Epic`)
};

const tr_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Başarımlı Oyunlar`)
};

const cs_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry s Epic úspěchy`)
};

const bg_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игри с Epic постижения`)
};

const ru_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игры с достижениями Epic`)
};

const uk_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігри з досягненнями Epic`)
};

const ar_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ألعاب بها إنجازات Epic`)
};

const hi_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic उपलब्धियों वाले गेम`)
};

const th_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่มีความสำเร็จของ Epic`)
};

const ja_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic 実績対応ゲーム`)
};

const zh_cn2_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games with Epic Achievements`)
};

const zh_hant1_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games with Epic Achievements`)
};

const ko_components_achievementsblade_gameswithachievements3 = /** @type {(inputs: Components_Achievementsblade_Gameswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games with Epic Achievements`)
};

/**
* | output |
* | --- |
* | "Games with Epic Achievements" |
*
* @param {Components_Achievementsblade_Gameswithachievements3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_achievementsblade_gameswithachievements3 = /** @type {((inputs?: Components_Achievementsblade_Gameswithachievements3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Achievementsblade_Gameswithachievements3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "ms") return ms_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "da") return da_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "de") return de_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "en-US") return en_us2_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "es-ES") return es_es2_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "es-MX") return es_mx2_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "fil") return fil_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "fr") return fr_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "it") return it_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "hu") return hu_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "nl") return nl_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "no") return no_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "pl") return pl_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "pt-BR") return pt_br2_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "pt") return pt_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "ro") return ro_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "fi") return fi_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "sv") return sv_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "vi") return vi_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "tr") return tr_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "cs") return cs_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "bg") return bg_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "ru") return ru_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "uk") return uk_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "ar") return ar_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "hi") return hi_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "th") return th_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "ja") return ja_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_achievementsblade_gameswithachievements3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_achievementsblade_gameswithachievements3(inputs)
	return ko_components_achievementsblade_gameswithachievements3(inputs)
});
export { components_achievementsblade_gameswithachievements3 as "components.achievementsBlade.gamesWithAchievements" }